import type { PlatformSubscriptionPlan } from '@/types/platform'

export type OwnerStatus = 'INACTIVE' | 'SUSPENDED' | 'EXPIRED' | 'ACTIVE'

type OwnerLike = {
  isActive: boolean
  suspendedAt?: string | Date | null
  plan: PlatformSubscriptionPlan | string
  nextRenewalAt?: string | Date | null
}

const toDate = (v?: string | Date | null) => (v ? new Date(v) : null)

export function resolveOwnerStatus(
  owner: OwnerLike,
  at = new Date()
): OwnerStatus {
  if (!owner.isActive) return 'INACTIVE'
  if (owner.suspendedAt) return 'SUSPENDED'

  const next = toDate(owner.nextRenewalAt)

  if (next && at.getTime() > next.getTime()) return 'EXPIRED'
  return 'ACTIVE'
}

/**
 * IMPORTANT:
 * Comme resolveOwnerStatus retourne SUSPENDED avant EXPIRED,
 * on calcule aussi "billingExpired" séparément pour bloquer Unsuspend si besoin.
 */
export function isBillingExpired(owner: OwnerLike, at = new Date()) {
  const next = toDate(owner.nextRenewalAt)
  return !!next && at.getTime() > next.getTime()
}
